"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeDialog = void 0;
var update_search_1 = require("./update-search");
var closeDialog = function (_a) {
    var _b;
    var history = _a.history, location = _a.location, _c = _a.key, key = _c === void 0 ? 'pwaOverlay' : _c;
    // `MemoryHistory` instances: `history.index` is used to indicate the initial entry
    // `BrowserHistory` instances: `location.key` is used: https://github.com/ReactTraining/history/blob/master/docs/api-reference.md#locationkey
    //  - in v4, it defaults to `undefined` (https://github.com/ReactTraining/history/blob/3f69f9e07b0a739419704cffc3b3563133281548/modules/createBrowserHistory.js#L54)
    //  - in v5, it defaults to `'default'` (https://github.com/ReactTraining/history/blob/v5.0.0/docs/api-reference.md#locationkey)
    if (history['index'] === 0 || typeof location.key === 'undefined' || location.key === 'default') {
        (0, update_search_1.updateSearch)({ history: history, location: location, newParams: (_b = {}, _b[key] = undefined, _b), replace: true });
    }
    else {
        history.goBack();
    }
};
exports.closeDialog = closeDialog;
//# sourceMappingURL=close-dialog.js.map